import { Modal } from "flowbite-react";
import { IRenter } from "../../../../../../types/renter.type";
import UnlinkVehicleModal from "./formsModal/UnlinkVehicleModal";
import { IVehicleVisualRecord } from "@/types/vehicle-visual-record.type";
import { FormikProvider, useFormik } from "formik";

type Props = {
  onClose: () => void;
  data: IRenter;
  register: IVehicleVisualRecord[];
  vehicleId: string;
};

type Photo = {
  type: string;
  content: string;
};

export interface UnlinkVehicleFormValues {
  renterId?: string;
  renterName: string;
  licensePlate: string;
  vehicle: {
    _id: string;
  };
  registers: Photo[];
  returnReason: string;
  optionRepossesion: string;
  withoutPhotos: boolean;
  changeVehicle: boolean | "";
  partsEvaluation: { [key: string]: boolean };
}

const registerProps = [
  { type: "Frente do veículo", content: "" },
  { type: "Lateral direita do veículo", content: "" },
  { type: "Lateral esquerda do veículo", content: "" },
  { type: "Traseira do veículo", content: "" },
  { type: "Odômetro", content: "" },
];

function buildCleanInitialValues(renter: IRenter): UnlinkVehicleFormValues {
  return {
    renterId: renter._id,
    renterName: renter.name,
    licensePlate: renter.activationData?.vehicle.licensePlate,
    vehicle: {
      _id: renter.activationData?.vehicle.id,
    },
    registers: registerProps,
    returnReason: "",
    optionRepossesion: "",
    withoutPhotos: false,
    changeVehicle: "",
    partsEvaluation: {},
  };
}

export function EditUnlinkBond(props: Props) {
  const { data: renter } = props;

  const formik = useFormik({
    initialValues: buildCleanInitialValues(renter),
    onSubmit: async (data) => {
      data;
    },
  });

  const handleCloseModal = () => {
    props.onClose();
  };

  return (
    <Modal
      className='relative text-black dark:text-black'
      size="5xl"
      show={true}
      onClose={() => handleCloseModal()}>
      <Modal.Header className=" h-12 items-center dark:text-black">
        <span className="dark:text-black">Desvincular Veículo</span>
      </Modal.Header>
      <Modal.Body
        className='w-full relative border-gray flex flex-col p-0'
        style={{ minHeight: 'auto' }}>
        <section>
          <div className="py-4">
            <FormikProvider value={formik}>
              <UnlinkVehicleModal onClose={handleCloseModal} />
            </FormikProvider>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer className="justify-end h-20 ">
        <button
          className="bg-redPrimary text-white font-semibold p-2 w-[100px] rounded-md mb-2 my-4 justify-end"
          type="button"
          onClick={() => handleCloseModal()}
        >
          Fechar
        </button>
      </Modal.Footer>
    </Modal >
  );
}
